import script from "./WebUpLoaderTst.vue?vue&type=script&setup=true&lang=js"
export * from "./WebUpLoaderTst.vue?vue&type=script&setup=true&lang=js"

import "./WebUpLoaderTst.vue?vue&type=style&index=0&id=419b3b40&scoped=true&lang=css"
import "./WebUpLoaderTst.vue?vue&type=style&index=1&id=419b3b40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419b3b40"]])

export default __exports__